<template>
  <b-nav-item
    :to="path ? path : '/'"
    class="nav-item"
  >

    <slot
      name="title"
    >
      <component
        :to="path"
        @click.native="linkClick"
        :is="linkType"
        class="nav-link"
        :href="path"
      >
          <i :class="icon"></i>
          <span class="nav-link-text">{{ name }}</span>
      </component>
    </slot>
  </b-nav-item>
</template>
<script>

export default {
  name: 'sidebar-item',
  props: {
    name: {
      type: String,
      default: 'link',
    },
    path: {
      type: String,
      default: '/'
    },
    icon: {
      type: String,
      default: 'fas fa-trash-alt c-orange'
    }
  },
  computed: {
    linkType(){ return 'router-link' }
  },
  methods: {
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>
<style>
.sidebar-menu-item {
  cursor: pointer;
}
</style>
